import { IApiKeyHolder, apiKeyHolder } from "@/utils/apikey";
import { IConfig, config } from "@/utils/config";

export interface Airline {
  name: string;
  icaoCode: string;
}

export interface IAirlineService {
  search(query: string): Promise<Airline[]>;
}

export class AirlineService implements IAirlineService {
  public constructor(
    private readonly _config: IConfig,
    private readonly apiKeyHolder: IApiKeyHolder,
  ) {}

  private allAirlines: Promise<Airline[]> = null;

  private async loadAllAirlines(): Promise<Airline[]> {
    if (this.allAirlines === null) {
      this.allAirlines = fetch(
        `${this._config.serviceBaseUrl}/co2footprint/airlines`,
        {
          headers: {
            "x-api-key": this.apiKeyHolder.getApiKey(),
          },
        },
      ).then((res) => res.json());
    }
    return this.allAirlines;
  }

  public async search(query = ""): Promise<Airline[]> {
    const allAirlines = await this.loadAllAirlines();
    return allAirlines.filter(
      (a) =>
        a.name.toLowerCase().includes(query.toLowerCase()) ||
        a.icaoCode.toLowerCase().includes(query.toLowerCase()),
    );
  }
}

export const defaultAirlineService = new AirlineService(config, apiKeyHolder);
